module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "overwrite-left"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    },
    slot: "overwrite-left"
  }, [_vm._v(" 关闭")]), _vm._v("\n    域名解析\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('div', {
    staticClass: "alert-warn"
  }, [_vm._v("\n      需进行实名认证后解析才能生效！\n    ")]), _vm._v(" "), _c('group', {
    staticStyle: {
      "margin": "0 0.1rem",
      "border-radius": "0.3rem"
    },
    attrs: {
      "label-width": "5em"
    }
  }, [_c('cell', {
    attrs: {
      "title": "解析类型",
      "value-align": "left",
      "value": _vm.analyList.set_type
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "子域名",
      "value-align": "left",
      "value": _vm.analyList.title
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "label-width": "5em",
      "title": "指向"
    },
    model: {
      value: (_vm.analyList.content),
      callback: function($$v) {
        _vm.$set(_vm.analyList, "content", $$v)
      },
      expression: "analyList.content"
    }
  }), _vm._v(" "), _c('popup-picker', {
    attrs: {
      "title": "TTL",
      "data": _vm.list1,
      "columns": 1
    },
    model: {
      value: (_vm.analyList.ttl),
      callback: function($$v) {
        _vm.$set(_vm.analyList, "ttl", $$v)
      },
      expression: "analyList.ttl"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "label-width": "5em",
      "title": "优先级"
    },
    model: {
      value: (_vm.analyList.mx_priority),
      callback: function($$v) {
        _vm.$set(_vm.analyList, "mx_priority", $$v)
      },
      expression: "analyList.mx_priority"
    }
  })], 1), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": "0.2rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-406857d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/changeanaly.vue
// module id = GZdz
// module chunks = 1